import type {
    OpenMeetingDetailsPageActionMessage,
    OpenMeetingTypePageActionMessage,
    OpenBookingPageActionMessage,
    EditBookingMeetingActionMessage,
    OpenBookingComposeActionMessage,
    OpenBookingDashboardActionMessage,
} from './actions/bookWithMeRoutesActions';
import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "BookwithmeRoutes" */ './lazyIndex'),
    { name: 'BookwithmeRoutes' }
);

// Lazy Actions
export const lazyOpenBookingDashboard: LazyAction<
    (
        isOnPopStateOrFirstLoad?: boolean | null,
        entryPoint?: string | null
    ) => OpenBookingDashboardActionMessage,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.openBookingDashboard);
export const lazyOpenBookingCompose: LazyAction<
    (
        isOnPopStateOrFirstLoad?: boolean | null,
        entryPoint?: string | null
    ) => OpenBookingComposeActionMessage,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.openBookingCompose);
export const lazyEditBookingMeeting: LazyAction<
    (
        meetingTypeId: string,
        isOnPopStateOrFirstLoad?: boolean | null,
        entryPoint?: string | null
    ) => EditBookingMeetingActionMessage,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.editBookingMeeting);
export const lazyOpenBookingPage: LazyAction<
    (bookingMailbox: string, entryPoint?: string | null) => OpenBookingPageActionMessage,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.openBookingPage);
export const lazyOpenMeetingTypePage: LazyAction<
    (
        bookingMailbox: string,
        meetingTypeId: string,
        entryPoint?: string | null
    ) => OpenMeetingTypePageActionMessage,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.openMeetingTypePage);
export const lazyOpenMeetingDetailsPage: LazyAction<
    (
        bookingMailbox: string,
        bookingId: string,
        entryPoint?: string | null
    ) => OpenMeetingDetailsPageActionMessage,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.openMeetingDetailsPage);
export const lazyRetriggerCurrentModule: LazyAction<
    () => {},
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.retriggerCurrentModule);

// Selectors
export { default as getBookWithMeModule } from './selectors/getCurrentModule';

// Actions exported non-lazily for organizer and attendee orchestrators to subscribe
export {
    openBookingCompose,
    editBookingMeeting,
    openBookingPage,
    openMeetingTypePage,
    openMeetingDetailsPage,
} from './actions/bookWithMeRoutesActions';
